var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _path, _path2, _path3, _path4, _circle7, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSignContract(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 146,
    height: 147,
    viewBox: "0 0 146 147",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 115.08,
    cy: 26.8803,
    r: 17.64,
    fill: "#FFD445"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.9004,
    cy: 101.22,
    r: 10.5,
    fill: "#FFD445"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 134.82,
    cy: 135.66,
    r: 10.5,
    fill: "#FFD445"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 33.1804,
    cy: 121.38,
    r: 3.78,
    fill: "#FFD445"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 136.5,
    cy: 67.6203,
    r: 3.78,
    fill: "#FFD445"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 75.1801,
    cy: 76.0203,
    r: 49.14,
    fill: "#FFD445"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.6205 145.81C70.9066 145.81 73.5705 143.146 73.5705 139.86C73.5705 136.574 70.9066 133.91 67.6205 133.91C64.3344 133.91 61.6705 136.574 61.6705 139.86C61.6705 143.146 64.3344 145.81 67.6205 145.81ZM67.6205 147C71.5638 147 74.7605 143.804 74.7605 139.86C74.7605 135.917 71.5638 132.72 67.6205 132.72C63.6772 132.72 60.4805 135.917 60.4805 139.86C60.4805 143.804 63.6772 147 67.6205 147Z",
    fill: "#FFD445"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7776 13.7199C12.4753 16.7812 10.6586 23.5612 13.7199 28.8635C16.7812 34.1658 23.5612 35.9825 28.8635 32.9212C34.1658 29.8599 35.9825 23.0799 32.9212 17.7776C29.86 12.4753 23.0799 10.6586 17.7776 13.7199ZM14.7846 8.53591C6.61931 13.2502 3.82166 23.6911 8.53592 31.8565C13.2502 40.0218 23.6911 42.8194 31.8565 38.1052C40.0218 33.3909 42.8195 22.95 38.1052 14.7846C33.3909 6.6193 22.95 3.82166 14.7846 8.53591Z",
    fill: "#FFD445"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.55305 48.9634C8.36371 49.6501 7.95621 51.1709 8.64287 52.3602C9.32954 53.5496 10.8504 53.9571 12.0397 53.2704C13.229 52.5837 13.6365 51.0629 12.9499 49.8736C12.2632 48.6842 10.7424 48.2767 9.55305 48.9634ZM9.30439 48.5327C7.87717 49.3567 7.38817 51.1817 8.21217 52.6089C9.03618 54.0361 10.8611 54.5251 12.2884 53.7011C13.7156 52.8771 14.2046 51.0521 13.3806 49.6249C12.5566 48.1977 10.7316 47.7087 9.30439 48.5327Z",
    fill: "#FFD445"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.0731 125.403C73.8837 126.09 73.4762 127.611 74.1629 128.8C74.8496 129.99 76.3704 130.397 77.5597 129.71C78.7491 129.024 79.1566 127.503 78.4699 126.314C77.7832 125.124 76.2624 124.717 75.0731 125.403ZM74.8244 124.973C73.3972 125.797 72.9082 127.622 73.7322 129.049C74.5562 130.476 76.3812 130.965 77.8084 130.141C79.2356 129.317 79.7246 127.492 78.9006 126.065C78.0766 124.638 76.2516 124.149 74.8244 124.973Z",
    fill: "#FFD445"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 74.7602,
    cy: 76.4403,
    r: 57.12,
    stroke: "#363853",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeDasharray: "6 10"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.4603 58.4504C29.7464 58.4504 32.4103 55.7864 32.4103 52.5004C32.4103 49.2143 29.7464 46.5504 26.4603 46.5504C23.1742 46.5504 20.5103 49.2143 20.5103 52.5004C20.5103 55.7864 23.1742 58.4504 26.4603 58.4504ZM26.4603 59.6404C30.4036 59.6404 33.6003 56.4437 33.6003 52.5004C33.6003 48.557 30.4036 45.3604 26.4603 45.3604C22.517 45.3604 19.3203 48.557 19.3203 52.5004C19.3203 56.4437 22.517 59.6404 26.4603 59.6404Z",
    fill: "#FFD445"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M100.157 39.6899H49.1401V112.751H100.157V39.6899Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M101.732 113.381H47.8804V37.8003H101.732V113.381ZM50.3997 110.862H99.2123V40.3197H50.3997V110.862Z",
    fill: "#282D33"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M97.4404 65.5203H52.9204V84.8403H97.4404V65.5203Z",
    fill: "#AEB5B6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3273 56.6325H52.9194V59.1519H65.3273V56.6325Z",
    fill: "#282D33"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M71.1848 45.3581H52.9194V47.8775H71.1848V45.3581Z",
    fill: "#282D33"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M81.955 61.4821H52.9194V64.0015H81.955V61.4821Z",
    fill: "#282D33"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1073 50.5223H52.9194V53.0416H61.1073V50.5223Z",
    fill: "#282D33"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M97.6381 45.3581H89.4502V47.8775H97.6381V45.3581Z",
    fill: "#282D33"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M71.1848 97.3206H52.9194V99.8399H71.1848V97.3206Z",
    fill: "#282D33"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M81.955 102.044H52.9194V104.563H81.955V102.044Z",
    fill: "#282D33"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M81.2622 87.2424H52.9194V89.7618H81.2622V87.2424Z",
    fill: "#282D33"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3848 112.14L94.2119 60.3376L99.6331 61.9939L83.8059 113.796",
    fill: "#FFC400"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M85.0104 114.164L82.601 113.428L98.06 62.8305L95.0483 61.9103L79.5892 112.508L77.1798 111.772L93.375 58.7648L101.206 61.1572L85.0104 114.164Z",
    fill: "#282D33"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6169 92.3658L85.3765 90.7647L84.6403 93.1741L89.8808 94.7752L90.6169 92.3658Z",
    fill: "#282D33"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6843 88.8722L86.4438 87.2711L85.7077 89.6805L90.9482 91.2816L91.6843 88.8722Z",
    fill: "#282D33"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M86.138 75.9825L83.7286 75.2464L87.9614 61.3923L99.7073 64.981L98.9712 67.3904L89.6347 64.5378L86.138 75.9825Z",
    fill: "#282D33"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M83.6217 114.399L83.7874 113.857L78.3662 112.2L78.2006 112.742L78.0165 113.345L78.1087 117.785L80.8193 118.614L83.4377 115.001L83.6217 114.399Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3544 120.094L76.897 118.733L76.7563 113.157L77.5293 110.628L85.3599 113.02L84.5869 115.55L81.3544 120.094ZM79.38 116.857L80.3438 117.151L82.0939 114.656L79.2628 113.792L79.38 116.857Z",
    fill: "#282D33"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignContract);
export default __webpack_public_path__ + "static/media/signContract.c01a834c5260916800cf5243284b6590.svg";
export { ForwardRef as ReactComponent };